// extracted by mini-css-extract-plugin
export var activeTitle = "styles-module--activeTitle--f57e0";
export var arrowIcon = "styles-module--arrowIcon--2c6ff";
export var chapterTitle = "styles-module--chapterTitle--4d93d";
export var chapterTitleContainer = "styles-module--chapterTitleContainer--ecbf8";
export var container = "styles-module--container--585b8";
export var sidebarSection = "styles-module--sidebarSection--5d99f";